import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=13b4ed34&"
import script from "./SearchView.vue?vue&type=script&lang=ts&"
export * from "./SearchView.vue?vue&type=script&lang=ts&"
import style0 from "./SearchView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports